import ajax from '../utils/axios'

// 问题类型列表
export const GetFirmList = (params) => ajax.get(`/index/firm/get_firm_list?limit=${params.limit}&page=${params.page}`)

// 新增问题类型
export const PostFirmAdd = (params) => ajax.post('/index/firm/add', params)

// 修改问题类型
export const PostFirmEdit = (params) => ajax.post('/index/firm/edit', params)

// // 问题类型详情
// export const GetUserList = (params) => ajax.get('/user/get_user_list', params)

